import paths, { rootPaths } from './paths';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {useAppContext} from "../providers/AppProvider";

import {
  faUser,
  faRunning,
  faShieldAlt,
  faBuilding,
  faChalkboardTeacher,
  faGavel,
  faBalanceScale,
  faIdBadge,
  faUserTie,
  faUsers,
  faUserShield,
  faUserCircle,
  faUserPlus,
  faClipboardCheck,
  faExchangeAlt,
  faArrowsRotate,
  faUserSlash,
  faFileAlt,
  faBook,
  faClipboard,
  faBan,
  faTrophy,
  faCalendarAlt,
  faArchive,
  faBasketballBall
} from '@fortawesome/free-solid-svg-icons';

export const dashboardRoutes = {
  label: 'Dashboard',
  labelDisable: true,
  children: []
};

const ROLE_ADMIN = 'admin';

const ROUTE_ACCESS = {
  adminOnly: [ROLE_ADMIN],
  clubs: [ROLE_ADMIN, 'clubs'],
  judges: [ROLE_ADMIN, 'judge'],
  supervisors: [ROLE_ADMIN, 'supervisor'],
  staff: [ROLE_ADMIN, 'staff'],
  playedMatches: [ROLE_ADMIN, 'clubs', 'judge', 'supervisor'],
  sportsHalls: [ROLE_ADMIN],
  default: '*'
};

const hasRouteAccess = (user, access = ROUTE_ACCESS.default) => {
  const role = user?.role_type_id;

  if (access === ROUTE_ACCESS.default) {
    return true;
  }

  return access.includes(role);
};

const filterVisibleRoutes = (routes, user) =>
  routes.reduce((visibleRoutes, route) => {
    if (!hasRouteAccess(user, route.access)) {
      return visibleRoutes;
    }

    const children = route.children
      ? filterVisibleRoutes(route.children, user)
      : route.children;

    if (route.children && (!children || children.length === 0)) {
      return visibleRoutes;
    }

    visibleRoutes.push({
      ...route,
      children
    });

    return visibleRoutes;
  }, []);

export const getAppRoutes = (user) => {
  return {
    label: 'app',
    labelDisable: false,
    children: filterVisibleRoutes([
      {
        name: 'Klubovi',
        icon: faBuilding,
        to: rootPaths.clubs,
        active: true,
        access: ROUTE_ACCESS.adminOnly
      },
      {
        name: 'Igrači',
        icon: faRunning,
        to: rootPaths.players,
        active: true,
        access: ROUTE_ACCESS.clubs
      },
      {
        name: 'Arhiva',
        icon: faArchive,
        to: rootPaths.archive,
        active: true,
        access: ROUTE_ACCESS.adminOnly
      },
      {
        name: 'Trener',
        icon: faChalkboardTeacher,
        to: rootPaths.coachs,
        active: true,
        access: ROUTE_ACCESS.clubs
      },
      {
        name: 'Sudije',
        icon: faBalanceScale,
        to: rootPaths.judges,
        active: true,
        access: ROUTE_ACCESS.adminOnly
      },
      {
        name: 'Supervizori',
        icon: faUserTie,
        to: rootPaths.supervisors,
        active: true,
        access: ROUTE_ACCESS.adminOnly
      },
      {
        name: 'Ostalo osoblje',
        icon: faUserShield,
        to: rootPaths.staff,
        active: true,
        access: ROUTE_ACCESS.adminOnly
      },
      {
        name: 'Sportske sale',
        icon: faBasketballBall,
        to: rootPaths.sportsHalls,
        active: true,
        access: ROUTE_ACCESS.sportsHalls
      },
      {
        name: 'Dokumentacija',
        icon: faBook,
        active: true,
        access: ROUTE_ACCESS.clubs,
        children: [
          {
            name: 'Registracija',
            to: rootPaths.registration,
            access: ROUTE_ACCESS.clubs,
            active: true
          },
          {
            name: 'Promjena članstva',
            to: rootPaths.membership,
            access: ROUTE_ACCESS.clubs,
            active: true
          },
          {
            name: 'Prekid članstva',
            to: rootPaths.termination,
            access: ROUTE_ACCESS.clubs,
            active: true
          },
          {
            name: 'Ugovori',
            to: rootPaths.contract,
            access: ROUTE_ACCESS.clubs,
            active: true
          }
        ]
      },
      {
        name: 'Takmičenja',
        icon: faTrophy,
        active: true,
        access: ROUTE_ACCESS.clubs,
        children: [
          {
            name: 'Evidencija takmičenja',
            to: rootPaths.competitions,
            active: true,
            access: ROUTE_ACCESS.adminOnly
          },
          {
            name: 'Licenciranje igrača',
            to: rootPaths.license,
            access: ROUTE_ACCESS.clubs,
            active: true
          }
        ]
      },
      {
        name: 'Mečevi',
        icon: faCalendarAlt,
        active: true,
        children: [
          {
            name: 'Odigrane utakmice',
            to: rootPaths.playedMatches,
            access: ROUTE_ACCESS.playedMatches,
            active: true
          },
          {
            name: 'Raspored Kola',
            to: rootPaths.roundSchedule,
            access: ROUTE_ACCESS.adminOnly,
            active: true
          },
          {
            name: 'Raspored utakmica',
            to: rootPaths.matchSchedule,
            access: ROUTE_ACCESS.adminOnly,
            active: true
          },
          {
            name: 'Aktivne utakmice',
            to: rootPaths.activeMatches,
            active: true
          }
        ]
      }
    ], user)
  }
};

export const getPagesRoutes = (user) => {
  return{
    label: 'Settings',
    labelDisable: !hasRouteAccess(user, ROUTE_ACCESS.adminOnly),
    children: filterVisibleRoutes([
      {
        name: 'Korisnici',
        icon: faUsers,
        to: rootPaths.users,
        active: true,
        access: ROUTE_ACCESS.adminOnly
      }
    ], user)
  }
};

export const modulesRoutes = {
  label: 'Modules',
  children: []
};

export const documentationRoutes = {
  label: 'documentation',
  children: []
};

export const getAllRoutes = (userApp) => [
  getAppRoutes(userApp),
  getPagesRoutes(userApp)
];
